// extracted by mini-css-extract-plugin
export default {"container":"DiagramInfo_container__Z-UZa","gif":"DiagramInfo_gif__VSILh","title":"DiagramInfo_title__ie63J","description":"DiagramInfo_description__mNozT"};